import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgX = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.763 5.339 C 5.589 5.417,5.389 5.628,5.323 5.801 C 5.250 5.993,5.262 6.329,5.348 6.501 C 5.389 6.583,7.074 8.304,9.093 10.325 L 12.763 14.000 9.093 17.675 C 7.074 19.696,5.389 21.417,5.348 21.499 C 5.262 21.671,5.250 22.007,5.323 22.199 C 5.391 22.377,5.592 22.585,5.774 22.662 C 5.975 22.749,6.317 22.744,6.501 22.652 C 6.583 22.611,8.304 20.926,10.325 18.907 L 14.000 15.237 17.675 18.907 C 19.696 20.926,21.417 22.611,21.499 22.652 C 21.683 22.744,22.025 22.749,22.226 22.662 C 22.408 22.585,22.609 22.377,22.677 22.199 C 22.750 22.007,22.738 21.671,22.652 21.499 C 22.611 21.417,20.926 19.696,18.907 17.675 L 15.237 14.000 18.907 10.325 C 20.926 8.304,22.611 6.583,22.652 6.501 C 22.738 6.329,22.750 5.993,22.677 5.801 C 22.609 5.623,22.408 5.415,22.226 5.338 C 22.025 5.251,21.683 5.256,21.499 5.348 C 21.417 5.389,19.696 7.074,17.675 9.093 L 14.000 12.763 10.325 9.093 C 8.304 7.074,6.583 5.389,6.501 5.348 C 6.320 5.258,5.955 5.254,5.763 5.339 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "black"
	})
});
export default SvgX;
